export default "<div class=\"icon <%- name %>\"></div>\n<% if (name !== \"logo\") { %>\n    <div class=\"title\"><%- title %></div>\n<% } %>\n";